export const form = {
  formCopyLink: 'Copia link',
  formLinkCopied: 'Link copiato!'
}
